import React from 'react';
import { Step, Stepper, Button, LinearProgress, Box, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { backArrow } from '../../assets';
import { Link } from 'react-router-dom';

export interface ProgressBarStepperProps {
  steps: Array<StepObj>;
  activeStep: number;
  title: string,
  onBack?: () => void;
  onNext?: () => void;
  baseUrl?: string
}

export interface StepObj {
  label?: string;
  content: JSX.Element;
  onBack?: () => void;
  onNext?: () => void;
  allowBack?: boolean;
  labelIndexNumber?: number;
  allowNext?: boolean;
  nextButtonText?: string;
  backButtonText?: string;
  buttonText: string;
  subLabel?: string;
  contentHasBorder?: boolean
  handleSubLabelClick?: (number) => void;
  backToHome?: boolean
}

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    stepperSection: {
      borderRadius: '16px 0px 0px 16px',
      height: '100%'
    },
    stepper: {
      background: 'transparent',
      padding: theme.spacing(6, 4),
      position: 'sticky',
      top: 0,
    },
    circle: {
      height: '24px',
      width: '24px',
      borderRadius: '50%',
      textAlign: 'center',
      marginRight: '10px',
      fontWeight: 'bolder',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      color: theme.palette.primary.main,
      border: `solid 2px ${theme.palette.primary.main}`,
    },
    arrow: {
      marginTop: '2px',
      marginRight: '4px',
      height: '20px',
    },
    stepContent: {
      border: 'solid 1px #BABEC5',
      borderRadius: '14px',
      padding: '40px',
      marginTop: theme.spacing(4),
    },
    stepperLabel: {
      color: theme.palette.primary.main,
      fontSize: '15px',
      fontWeight: 500,
      letterSpacing: '1.25px',
      textTransform: 'uppercase',
    },
    stepperLabelContainer: {
      display: 'flex',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    subLabel: {
      fontSize: '28px',
      lineHeight: '133 %',
      fontWeight: 400,
      maxWidth: '1065px',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 16,
    },
    progressBar: {
      backgroundColor: '#58ABDE'
    },
    title: {
      textAlign: 'center',
      fontSize: '54px',
      fontWeight: 400,
      lineHeight: '117%',
      letterSpacing: '0px'
    },
    button: {
      width: '358px',
      height: '40px',
      letterSpacing: '1.25px',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      }
    },
    buttonBack: {
      color: '#0F172A',
      fontSize: '14px',
      textTransform: 'uppercase',
    },
    stepFooter: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(2),
    },
    backToHomeButton: {
      width: '358px',
      height: '40px',
      fontSize: 16,
      letterSpacing: '1.25px',
      marginRight: 20,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      color: 'rgba(24, 24, 27, 1)',
      borderRadius: '8px',
      border: 'solid 1px rgba(228, 228, 231, 1)'
    },
    buttonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })
);
const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 4,
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
    bar: {
      backgroundColor: theme.palette.primary.main,
    },
  })
)(LinearProgress);
const Circle = ({ text }) => {
  const classes = useStyle();
  return <div className={classes.circle}>{text}</div>
}
export const ProgressBarStepper: React.FC<ProgressBarStepperProps> = ({
  steps,
  activeStep,
  title,
  baseUrl,
  onBack,
  onNext,
}) => {
  const classes = useStyle();
  const value = Math.round(((activeStep + 1) / steps.length) * 100);

  return (
    <div className={classes.stepperSection}>
      {activeStep !== 0 && steps[activeStep]?.allowBack &&
        <Button onClick={onBack}><img className={classes.arrow} src={backArrow} alt="back"/>
          <div style={{fontSize: 'large'}}>Back</div>
        </Button>
      }
      <Typography variant="h4" className={classes.title}>{title}</Typography>
      <Stepper activeStep={activeStep} orientation="vertical"
        className={classes.stepper}>
        {
          steps.filter(step => step.label).map((step, i) => (
            <>
              {activeStep === i && <Step key={step.label}>
                <Box>
                  <BorderLinearProgress
                    className={classes.progressBar}
                    variant="determinate" value={value} />
                </Box>
                <Box className={classes.stepperLabelContainer}>
                  <Circle text={step?.labelIndexNumber} />
                  <Typography className={classes.stepperLabel}>{step.label}</Typography>
                </Box>
                <Box className={classes.stepContent} style={{
                  border: step?.contentHasBorder ? 'solid 1px #BABEC5' : 'none'
                }}>
                  <Typography className={classes.subLabel}>{step?.subLabel}</Typography>
                  {step?.content}
                </Box>
              </Step>}
            </>
          ))
        }
        <Box className={classes.buttonContainer}>
          {steps[activeStep]?.backToHome && <Box className={classes.stepFooter}>
            <Link to={baseUrl}>
              <Button className={classes.backToHomeButton} disabled={false} onClick={steps[activeStep]?.onNext}>BACK TO HOME</Button></Link>
          </Box>}
          {steps[activeStep]?.allowNext && <Box className={classes.stepFooter}>
            <Button className={classes.button} disabled={false} onClick={steps[activeStep]?.onNext}>{steps[activeStep]?.buttonText}</Button>
          </Box>}
        </Box>
      </Stepper>
    </div >
  );
};